import { Action } from 'redux';
import { ProductFilters, ProductModel } from '../../../api/core/core.types';
import { Page } from '../../../api/api.types';

export const GET_PRODUCT_LIST = 'GET_PRODUCT_LIST';
export const GET_PRODUCT = 'GET_PRODUCT';
export const POST_PRODUCT = 'POST_PRODUCT';
export const PUT_PRODUCT = 'PUT_PRODUCT';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const UPDATE_PRODUCT_FILTERS = 'UPDATE_PRODUCT_FILTERS';

export interface GetProductListAction extends Action {
  type: typeof GET_PRODUCT_LIST;
  payload: {
    page: Page<ProductModel>;
  };
}

export interface GetProductAction extends Action {
  type: typeof GET_PRODUCT;
  payload: {
    selectedProduct: ProductModel | null;
  };
}

export interface PostProductAction extends Action {
  type: typeof POST_PRODUCT;
  payload: {
    success: boolean;
    newProduct: ProductModel | null;
  };
}

export interface PutProductAction extends Action {
  type: typeof PUT_PRODUCT;
  payload: {
    selectedProduct: ProductModel;
  };
}

export interface DeleteProductAction extends Action {
  type: typeof DELETE_PRODUCT;
  payload: {
    success: boolean;
  };
}

export interface UpdateProductFilters extends Action {
  type: typeof UPDATE_PRODUCT_FILTERS;
  payload: {
    filters: ProductFilters;
  };
}

export interface ProductState {
  products: ProductModel[] | [];
  selectedProduct: ProductModel | null;
  postSuccess: boolean | null;
  lastFetch: number | null;
  filters: ProductFilters | null;
  totalElements: number;
  totalPages: number;
}

export type ProductActionTypes = GetProductAction | GetProductListAction | PostProductAction | DeleteProductAction | PutProductAction | UpdateProductFilters;
